import {combineReducers, configureStore} from '@reduxjs/toolkit'
import dialog from "./slices/dialog";
import map from "./slices/map";

const reducer = combineReducers({
    dialog,
    map
});

export const store = configureStore({reducer});